import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../constants';

import SvgComponent from '../SvgComponent';

import './SuccessMessageComponent.scss';

const SuccessMessageComponent = ({ message, onClose, visible, className, i18n }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (visible && containerRef.current) {
            containerRef.current.focus();
        }
    }, [visible]);

    if (!visible) return null;

    return (
        <div
            ref={containerRef}
            tabIndex="-1"
            role="status"
            aria-live="polite"
            className={`success-message ${className || ''}`}>
            <div className="message">
                <div className="picto">
                    <SvgComponent
                        src={`${STATIC_ROOT}/icon/picto-validation.svg`}
                        width="24"
                        height="24"
                        aria-hidden="true"
                        focusable="false"
                    />
                </div>
                <div>{message}</div>
            </div>
            {onClose && (
                <button type="button" className="close-message" onClick={onClose}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/croix.svg`}
                        width="20"
                        height="20"
                        role="img"
                        aria-label={i18n.CLOSE_MESSAGE}
                    />
                </button>
            )}
        </div>
    );
};

SuccessMessageComponent.propTypes = {
    message: PropTypes.node.isRequired,
    onClose: PropTypes.func,
    visible: PropTypes.bool,
    className: PropTypes.string
};

SuccessMessageComponent.defaultProps = {
    visible: true
};

const mapStateToProps = state => ({
    i18n: state.i18n.feature.SUCCESS_MESSAGE
});

export default connect(mapStateToProps)(SuccessMessageComponent);



// WEBPACK FOOTER //
// ./src/components/form-message/SuccessMessageComponent.js